import { Link } from 'react-router-dom';

export function SidebarNav({ links, activeKey, onLinkClick }) {
  return (
    <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
      {links.map((link) => (
        <Link
          key={link.key}
          to={link.href}
          className={`sidebar-link ${activeKey === link.key ? 'active' : ''}`}
          onClick={onLinkClick}
          data-testid={`nav-${link.key}`}
        >
          <link.icon className="w-4 h-4 mr-3 flex-shrink-0" />
          <span className="truncate">{link.label}</span>
        </Link>
      ))}
    </nav>
  );
}
